<template>
  <section class="content">
    <header class="content__title">
      <h1>报修列表</h1>
    </header>

    <div class="card">
      <div class="card-body" v-loading="report_list_loading">
        <div class="table-responsive no-overflow-table">
          <div class="dataTables_wrapper">
            <div id="data-table_filter" class="dataTables_filter">
              <label>
                搜索:
                <input type="search" placeholder="输入文字开始搜索" v-model="filter.searchText">
              </label>
            </div>
          </div>

          <el-table
            :data="report_list_data"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @filter-change="handleFilterChange"
            @expand-change="handleRowExpands"
            style="width: 100%"
            border
            fit
            stripe>
            <el-table-column type="expand">
              <template slot-scope="props">
                <template v-if="report_steps_querying">
                  <div v-loading="true"></div>
                </template>
                <template v-else>
                  <el-steps
                    direction="vertical"
                    class="ticket-steps"
                    :active="report_steps_steps.length"
                    v-if="report_steps_steps.length>0">
                    <el-step
                      v-for="(step, index) in report_steps_steps"
                      :key="step.id"
                      :title="step.progress"
                      :description="`[${formatDateTz(step.create_date)}] ${step.description}`"
                      :status="step.progress==='已完工' ? 'success' : 'process'"
                      :icon="step.progress==='已完工' ? 'el-icon-circle-check' : (index === 0 ? 'el-icon-loading' : 'el-icon-check')"/>
                  </el-steps>
                  <el-alert v-else
                            title="当前还未产生进度"
                            type="info"
                            :closable="false">
                  </el-alert>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in report_list_columns"
              :filters="item.filters"
              :column-key="item.column_key"
              :key="item.label"
              :prop="item.prop"
              :fixed="item.fixed"
              :label="item.label">
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              header-align="center"
              class-name="op-row"
              width="135">
              <template slot-scope="scope">
                <a class="btn btn-primary btn-sm" @click.prevent="handleViewDetail(scope.$index, scope.row)">详情</a>
                <a class="btn btn-info btn-sm"
                   v-if="report_list_additional_parameters.is_rate_enabled&&!scope.row['已评分']&&scope.row['进度']==='已完工'"
                   @click.prevent="handleRateTicket(scope.$index, scope.row)">评价</a>
                <a class="btn btn-info btn-sm"
                   v-if="scope.row['已评分']"
                   @click.prevent="handleShowTicketRate(scope.$index, scope.row)">查看评价</a>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10, 25, 50, 100]"
            :page-size="1"
            :total="report_list_total"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>
    </div>
    <rate-ticket-dialog :show.sync="is_rate_ticket_dialog_visible"
                        :ticket_id="current_rate_ticket_id"/>
    <ticket-rate-detail-dialog :show.sync="is_ticket_rate_detail_dialog_visible"
                        :ticket_id="current_show_ticket_rate_detail_id"/>
  </section>
</template>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import {date_format} from '../../utils/helper';
  import RateTicketDialog from './controls/rate-ticket-dialog';
  import TicketRateDetailDialog from './controls/ticket-rate-detail-dialog';

  export default {
    components: {RateTicketDialog, TicketRateDetailDialog},
    data() {
      return {
        filter: {
          pageIndex: 1,
          pageSize: 10,
          searchText: ''
        },
        expands: [],
        is_rate_ticket_dialog_visible: false,
        current_rate_ticket_id: 0,
        is_ticket_rate_detail_dialog_visible: false,
        current_show_ticket_rate_detail_id: 0,
      }
    },
    watch: {
      filter: {
        handler() {
          this.queryList();
        },
        deep: true
      }
    },
    computed: {
      ...mapGetters([
        'report_list_loading',
        'report_list_columns',
        'report_list_data',
        'report_list_total',
        'report_list_additional_parameters',
        'report_steps_querying',
        'report_steps_steps',
        'report_steps_current'
      ])
    },
    methods: {
      ...mapActions([
        'fetchReportList',
        'fetchTicketSteps'
      ]),
      formatDateTz(date) {
        return date_format(date);
      },
      handleSizeChange(val) {
        this.filter.pageSize = val;
      },
      handleCurrentChange(val) {
        this.filter.pageIndex = val;
      },
      queryList() {
        this.fetchReportList(this.filter);
      },
      handleViewDetail(index, item) {
        if (!this.report_list_additional_parameters || !this.report_list_additional_parameters.can_view_service_ticket) {
          this.$router.push({name: 'ViewRepairForm', params: {id: item.Id}});
        }
        else {
          this.$router.push({name: 'ViewServiceTicket', params: {id: item.Id}});
        }
      },
      getRowKeys(row) {
        return row.Id;
      },
      handleSmartViewTicket(row, column) {
        // if (column.label === "操作") {
        //   return;
        // }

        if (column.type === 'expand') {
          if (this.expands.length && this.expands[0] === row.Id) {
            this.expands = [];
          } else {
            this.fetchTicketSteps({ticketId: row.Id});
            this.expands = [row.Id];
          }
          // return;
        }
        //
        // if (!this.report_list_additional_parameters || !this.report_list_additional_parameters.can_view_service_ticket) {
        //   this.$router.push({name: 'ViewRepairForm', params: {id: row.Id}});
        // }
        // else {
        //   this.$router.push({name: 'ViewServiceTicket', params: {id: row.Id}});
        // }
      },
      handleRowExpands(row, expandedRows) {
        if (this.expands.length && this.expands[0] === row.Id) {
          this.expands = [];
        } else {
          this.fetchTicketSteps({ticketId: row.Id});
          this.expands = [row.Id];
        }
      },
      handleFilterChange(filters) {
        this.filter = {
          ...this.filter,
          ...filters
        };
      },
      handleRateTicket(index, item) {
        this.current_rate_ticket_id = item.Id;
        this.is_rate_ticket_dialog_visible = true;
      },
      handleShowTicketRate(index, item) {
        this.current_show_ticket_rate_detail_id = item.Id;
        this.is_ticket_rate_detail_dialog_visible = true;
      },
    },
    beforeCreated() {
    },
    created() {
    },
    mounted() {
      this.queryList();

      $('.dataTables_filter input[type=search]').focus(function () {
        $(this).closest('.dataTables_filter').addClass('dataTables_filter--toggled');
      });

      $('.dataTables_filter input[type=search]').blur(function () {
        $(this).closest('.dataTables_filter').removeClass('dataTables_filter--toggled');
      });
    }
  }
</script>
<style lang="scss">
  .el-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .el-table {
    margin-top: 10px;
  }

  table.el-table__body {
    border-collapse: initial;
  }

  .el-table__fixed-right {
    overflow-y: hidden
  }

  .no-overflow-table {
    overflow: visible;
    overflow-x: unset !important;

    .el-table {
      overflow: visible;

      .el-table__body-wrapper {
        overflow: visible;
      }
    }
  }

  .el-table__expanded-cell:hover {
    background-color: #fff !important;
  }

  .ticket-steps {
    .el-step__icon-inner[class*=el-icon].is-status {
      font-size: 25px;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/repair-list.vue